module.exports = __webpack_public_path__ + "static/media/01.6f646f2d.png";